import * as React from 'react';
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MuiDrawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import {

  Assignment,
  Description,
  Flag,
  School,
  Campaign,
  Subscriptions,
  WorkspacePremium,
  AccountBalance,
  SupportAgent,
  Info,
  AccountCircle,
  TravelExplore,
} from "@mui/icons-material";
import { Link as RouterLink, useLocation } from 'react-router-dom';
import {
  ChatBubbleOutlined,
  ExitToApp,
  Groups,
  Home,
  LibraryBooksOutlined,
  Person
} from '@mui/icons-material';
import AuthContext from '../../context/AuthContext';
import { useContext } from 'react';
import { useMediaQuery } from '@mui/material';

const drawerWidth = 280;

const openedMixin = (theme) => ({
  width: drawerWidth,
  backgroundColor: 'RGB(41 46 92)',
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  borderRight: 'unset',
  overflowX: 'hidden',
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  backgroundColor: 'RGB(41 46 92)',
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: '#556773',
  ...theme.mixins.toolbar,
}));

const PARENT_PORTAL_ROUTES = {
  "/dashboard": "/parent-portal/dashboard",
  "/assessment": "/parent-portal/assessment",
  "/reports": "/parent-portal/reports",
  "/career-skills": "/parent-portal/career-skills",
  "/council": "/parent-portal/council",
  "/admission-counsellor": "/parent-portal/admission-counsellor",
  "/milestone": "/parent-portal/milestone",
  "/chatbuddy": "/parent-portal/chatbuddy",
  "/subscription": "/parent-portal/subscription",
  "/feedback": "/parent-portal/feedback",
  "/how-it-works": "/parent-portal/how-it-works",
  "/dna": "/parent-portal/dna",
  "/profile": "/parent-portal/profile",
};

export default function SidebarMobile({ open, toggleSidebar }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const location = useLocation();
  const { logout, user } = useContext(AuthContext);

 const menuItems = [
        {
            text: "Dashboard",
            icon: <Home />,
            url: "/dashboard",
            roles: ["Admin", "School", "Student", "Parent"],
        },
        {
            text: "Assessment",
            icon: <Assignment />,
            url: "/assessment",
            roles: ["Student", "Parent"],
        },
        {
            text: "Reports",
            icon: <Description />,
            url: "/reports",
            roles: ["Student", "Parent", "School", "Admin"],

        },
        {
            text: "Career & Skills",
            icon: <School />,
            url: "/career-skills",
            roles: ["Student", "Parent"],

        },
        {
            text: "Career Guide",
            icon: <TravelExplore />,
            url: "/career-guide",
            roles: ["Student", "Parent"],

        },
        {
            text: "Counselling",
            icon: <Groups />,
            url: "/council",
            roles: ["Student", "Parent", "Admin"],

        },
        {
            text: "Admission Counsellor",
            icon: <AccountBalance />,
            url: "/admission-counsellor",
            roles: ["Student", "Parent", "Admin"],

        },

        {
            text: "My Milestone",
            icon: <Flag />,
            url: "/milestone",
            roles: ["Student", "Parent"],

        },
        {
            text: "Chat Buddy",
            icon: <Campaign />,
            url: "/chatbuddy",
            roles: ["Student", "Parent", "School", "Admin"],

        },

        {
            text: "Subscription",
            icon: <WorkspacePremium />,
            url: "/subscription",
            roles: ["Student", "Parent", "School", "Admin"],

        },
        {
            text: "Feedback",
            icon: <Subscriptions />,
            url: "/feedback",
            roles: ["Student", "Parent"],
        },

        {
            text: "Know The Process",
            icon: <Info />,
            url: "/how-it-works",
            roles: ["Student", "Parent"],
        },
        { text: 'Professional DNA', icon: <Groups />, url: '/dna', roles: ['Admin', 'School', 'Student', 'Parent'] },
        // {
        //     text: "Help Desk",
        //     icon: <SupportAgent />,
        //     url: "/",
        //     roles: ["Student", "School"],
        //     disable: true

        // },
        {
            text: "Profile",
            icon: <AccountCircle />,
            url: "/profile",
            roles: ["Student", "Parent"],
        },
        { text: 'Log Out', icon: <ExitToApp />, url: '/' },

    ];
  const filteredMenu = menuItems.filter(item => !item.roles || item.roles.includes(user?.role));
  const getItemUrl = (url) =>
    user?.role === "Parent" ? PARENT_PORTAL_ROUTES[url] || url : url;

  return (
    <MuiDrawer
     variant="temporary"
      open={open}
      onClose={toggleSidebar}
      ModalProps={{
        keepMounted: true, // Improves performance on mobile
      }}
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: drawerWidth,
          boxSizing: 'border-box',
          backgroundColor: 'RGB(41 46 92)',
          color: '#556773',
          ...(open ? openedMixin(theme) : closedMixin(theme)),
        },
      }}
    >
      <DrawerHeader sx={{ backgroundColor: 'RGB(41 46 92)', width: '280px', position: 'relative', mr: 2, mt: 2 }}>
        <img
          src="/assets/images/logo-white.png"
          alt="Company Logo"
          style={{ width: "150px", height: "28px", marginBottom: "17px" }}

        />
        <IconButton
          onClick={toggleSidebar}
          sx={{
            position: 'absolute',
            right: 0,
          }}
        >
          {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
        </IconButton>
      </DrawerHeader>
      <Divider />
      <Box className="logged-in-sidebar">
        <List>
          {filteredMenu.map((item) => {
            const itemUrl = getItemUrl(item.url);
            const isActive =
              (itemUrl === '/parent-portal/council' && location.pathname === '/parent-portal/chatbot') ||
              (itemUrl === '/council' && location.pathname === '/chatbot') ||
              (itemUrl === '/career-guide' && location.pathname.startsWith('/career-guide')) ||
              location.pathname === itemUrl;

            return (
              <ListItem disabled={item?.disable || false} key={item.text} disablePadding sx={{ display: 'block' }}>
                <ListItemButton
                  disabled={item?.disable || false}
                  className={isActive ? 'icon-style-active' : 'icon-style-nonactive'}
                  component={RouterLink}
                  to={itemUrl}
                  onClick={() => {
                    if (item.text === 'Log Out') logout();
                    if (isMobile) toggleSidebar(); // Close sidebar on mobile after navigation
                  }}
                  sx={{
                    minHeight: 48,
                    px: 2.5,
                    background: isActive ? 'RGB(247 170 71)' : 'inherit', // Active background color
                    boxShadow: isActive ? '0px 1px 0px 0px rgba(0, 0, 0, 0.25)' : 'none',
                    justifyContent: open ? 'initial' : 'center',
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      justifyContent: 'center',
                      color: isActive ? 'RGB(252 227 194)' : '#556773',
                      mr: open ? 3 : 'auto',
                    }}
                  >
                    {item.icon}
                  </ListItemIcon>
                  <ListItemText
                    primary={item.text}
                    sx={{
                      opacity: open ? 1 : 0,
                      color: isActive ? 'RGB (252 227 194)' : '#556773',
                      fontSize: '15px',
                    }}
                  />
                </ListItemButton>
              </ListItem>
            );
          })}
        </List>
      </Box>
    </MuiDrawer>
  );
}
